import axios from 'axios';
import config from '../../config';

export const api = axios.create({
  baseURL: config.API_BASE_URL,
  withCredentials: true,
});

export const publicApi = axios.create({
  baseURL: config.API_BASE_URL,
});

function getStoredCsrfToken() {
  try {
    return sessionStorage.getItem('csrfToken') || '';
  } catch {
    return '';
  }
}

async function refreshCsrfToken() {
  const { data } = await axios.get(`${config.API_BASE_URL}/csrf-token`, {
    withCredentials: true,
  });

  const token = data?.csrfToken || '';
  if (token) {
    try {
      sessionStorage.setItem('csrfToken', token);
    } catch {}
    api.defaults.headers.common['X-CSRF-Token'] = token;
  }
  return token;
}

const initialCsrfToken = getStoredCsrfToken();
if (initialCsrfToken) {
  api.defaults.headers.common['X-CSRF-Token'] = initialCsrfToken;
}

api.interceptors.request.use(async (cfg) => {
  const method = String(cfg.method || 'get').toLowerCase();
  const isMutating = ['post', 'put', 'patch', 'delete'].includes(method);

  if (isMutating) {
    const csrfToken = getStoredCsrfToken();
    if (csrfToken) {
      cfg.headers = cfg.headers || {};
      cfg.headers['X-CSRF-Token'] = csrfToken;
    }
  }

  return cfg;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const original = error?.config;
    const method = String(original?.method || 'get').toLowerCase();
    const isMutating = ['post', 'put', 'patch', 'delete'].includes(method);
    const contentType = String(error?.response?.headers?.['content-type'] || '').toLowerCase();
    const bodyText = typeof error?.response?.data === 'string' ? error.response.data : '';
    const bodyError = error?.response?.data?.error || error?.response?.data?.message || '';
    const looksLikeCsrf =
      status === 403 &&
      isMutating &&
      (
        /csrf/i.test(String(bodyError)) ||
        /forbidden/i.test(bodyText) ||
        contentType.includes('text/html')
      );

    if (looksLikeCsrf && original && !original.__soloCsrfRetried) {
      const token = await refreshCsrfToken();
      if (token) {
        original.__soloCsrfRetried = true;
        original.headers = original.headers || {};
        original.headers['X-CSRF-Token'] = token;
        return api(original);
      }
    }

    return Promise.reject(error);
  }
);

export function formatDateTime(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString();
}

export function formatDate(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString();
}
